export default [
    {
        path: 'relatorio-consulta-finalizada',
        component: () => import(
            /* webpackChunkName: 'ambulatorio-relatorio-consulta-finalizada' */
            '@/views/ambulatorio/relatorio-consulta-finalizada/Index'
        ),
        redirect: 'relatorio-consulta-finalizada/index',
        children: [
            {
                name: 'ambulatorio-relatorio-consulta-finalizada-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-relatorio-consulta-finalizada' */
                    '@/views/ambulatorio/relatorio-consulta-finalizada/List.vue'
                ),
            },
        ],
    },
]